import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Explore All Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Click any category to discover Basetao Spreadsheet product finds on our main shopping platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <a
              key={idx}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/60 transition-all duration-300 cursor-pointer"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 group-hover:bg-primary-100 group-hover:scale-110 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </span>
              <span className="text-xs md:text-sm font-label font-medium text-foreground-700 group-hover:text-primary-600 text-center whitespace-nowrap transition-colors duration-200">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}